<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
      <v-card class="fill-height">
        <v-card-title>
          <v-spacer/>
          <v-btn style="background-color:#be1e0b" dark icon @click.stop="closed">
            <v-icon >mdi-close</v-icon>
          </v-btn>

        </v-card-title>
        <v-card-text  class="mt-3">
          <v-form   >
            <v-row>
              <v-img :src="model.base64Img"  />
            </v-row>
          </v-form>
            <v-card-actions dir="ltr">
              <v-btn
                  fab
                  small
                  depressed
                  color="primary"
                  class="m-3"
                  @click="forDownload(model)"
              >
              <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
            </v-card-actions>
        </v-card-text>
      </v-card>

  </v-dialog>
</template>

<script>

import Slider_se from "./Slider_se";

export default {

  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,

  },
  methods: {

    closed() {
      this.$emit('update:dialogStatus', false)
    },

    forDownload(e) {
      Slider_se.showById(e.id)
    },

  },



}
</script>


